export default __webpack_public_path__ + "static/media/take-bait.ea791ab9.mp3";